import React from 'react';

import {
  AdSlot,
  ContainerId,
  type PlacementId,
  type RecommendationCategories
} from '@schibsted-nmp/advertising-shared';

/**
 * This component is used to render an advertising web component, only on the
 * client-side to help with hydration issues.
 */
export function AdvertisingClientWebComponent(
  props: AdvertisingClientWebComponent.Props
) {
  return <AdvertisingClientWebComponent.Forwarded {...props} />;
}

export namespace AdvertisingClientWebComponent {
  export type Props = React.ComponentProps<typeof Forwarded>;

  export const Forwarded = React.forwardRef<HTMLDivElement, Forwarded.Props>(
    (
      {
        placementId,
        adIndex,
        initialLayoutType,
        initialAspectFormat,
        categories
      },
      ref
    ) => {
      const [clientSide, setClientSide] = React.useState(false);

      React.useEffect(() => {
        setClientSide(true);
      }, []);

      if (!clientSide) return null;

      return (
        <advt-component
          adIndex={adIndex}
          placementId={placementId}
          initialLayoutType={initialLayoutType}
          initialAspectFormat={initialAspectFormat}
          categories={categories}
        >
          <div
            ref={ref}
            id={ContainerId.fromPlacementId(placementId)}
            slot={AdSlot.fromPlacementId(placementId)}
          ></div>
        </advt-component>
      );
    }
  );

  export namespace Forwarded {
    export type Props = {
      placementId: PlacementId;
      adIndex?: number | undefined;

      /** The categories of the item to get the `placementId` for. */
      categories?: RecommendationCategories | undefined;

      /** The initial layout type (Grid or List) */
      initialLayoutType?: string | undefined;

      /** The initial aspect format for retail media ads (portrait or landscape) */
      initialAspectFormat?: string | undefined;
    };
  }
}
